<template lang="pug">
  .table-responsive
    ModalUsoEquipo(:origen="origen" :config="configModal" :oficinas="oficinas" :ubicaciones="ubicaciones" :localizaciones="localizaciones" :estadosDB="estadosDB" @selectNewOffice="selectNewOffice" v-show="modalStatus")
    ModalDocumentosArt(v-show="modalStatusD" :tipo="tipoFileUp" :articulo="itemSelect" @padre:close="cerrarModalD" @subirDocumento="subirDocumento" @borrarDocumento="verModalDeleteDocumento")
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarDocumento")
    table#tbExistencias.table.is-striped.is-fullwidth
      thead
        tr
          th idSAP
          th Tag
          th Almacén
          th Descripción
          th Imágenes
          th Factura
      tbody
        tr(v-for="(data, index) in articulos" :key="data.id")
          td
            a.button.is-black.is-rounded.is-small {{ data.idSAP === ''? 's/idSAP' : data.idSAP == 0 ? '' : data.idSAP }}
          td 
            span.tag.is-black(v-show="data.tag !== ''")
              | {{ data.tag }}
          td
            a.button.is-black.is-rounded.is-small(@click="cambiarUbicacion(data)")
              | {{ data.oficina }}
            br
            span.tag(v-show="data.localizacion!== ''") {{ data.localizacion }}
          td
            a.button.is-black.is-small.is-rounded(@click="irEditarArticulo(data)")
              | {{ data.categoria }}{{ data.subcategoria !== '' ? ` - ${data.subcategoria}` : '' }}
            | &nbsp
            span.tag.is-warning(v-show="data.estado > 2") {{ data.estadoStr }}
            a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id)")
              i.fas.fa-history
            br
            span.tag.is-light.is-small(v-show=" data.marca !== ''") Marca: {{ data.marca }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.modelo !== ''") Modelo: {{ data.modelo }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.serie !== ''") Serie: {{ data.serie }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.partida !== ''") Partida: {{ data.partida }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.noParte !== ''") No. Parte: {{ data.noParte }} &nbsp&nbsp
            br
            span.tag.is-light.is-small(v-show="data.tipoAdm == 2") Precio Unit. {{ data.precioUnitario | currency }}
          td
            a.button.is-rounded.is-small(@click="verModalD(data, 'images')" :class="getClassTipo(data, '0')")
              i.far.fa-folder-open
              | &nbsp
              span {{ data.documentos == 0 ? ' Sin Documentos' : ` (${(data.documentos.filter( d => d.tipo === '0')).length}) Imágenes`}}
          td
            a.button.is-rounded.is-small(:class="data.rutaFac !== '' && data.rutaFac ? 'is-success': 'is-warning'" @click="verModalD(data, 'facturas')")
              i.far.fa-folder-open
              | &nbsp
              span Factura
          
</template>

<script>
  import ModalUsoEquipo from './ModalUsoEquipo.vue'
  import ModalDocumentosArt from './ModalDocumentosArt.vue'
  import ModalYN from '@/components/shared/ModalYN.vue'
  import moment from 'moment'
  import InventarioServices from '../../../services/inventario/inventario'
  import { mapState } from 'vuex'
  export default {
    name: 'TbAlmacenes',
    components: { ModalUsoEquipo, ModalDocumentosArt, ModalYN },
    props: {
      articulos: {
        type: Array,
        default: []
      },
      origen: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        itemCambiar: {},
        configModal: {},
        modalStatus: false,
        itemSelect: {},
        modalStatusD: false,
        tipoFileUp: '',
        documentoSelect: {},
        modalStatusYN: false,
        configModalYN: {},
        oficinas: [],
        ubicaciones: [
          { id: '1566247215482', nombre: 'IRGE', valor: 'IRGE' },
          { id: '1565899419222', nombre: 'TPA', valor: 'TPA' },
          { id: '1588283398540', nombre: 'CORPORATIVO', valor: 'CORPO' },
          { id: '1566322725551', nombre: 'EB04', valor: 'EB04' },
          { id: '1588173714497', nombre: 'DUCTO', valor: 'LPGD' },
          { id: '1565964784014', nombre: 'EB00', valor: 'EB00' },
          { id: '1566330159028', nombre: 'EB01', valor: 'EB01' },
          { id: '1566235785478', nombre: 'EB02', valor: 'EB02' },
          { id: '1566338236531', nombre: 'EB03', valor: 'EB03' },
          { id: '1588172064431', nombre: 'ERM-TLAUTLA', valor: 'ERM' }
        ],
        estadosDB: [],
        localizaciones: [],
      }
    },
    methods: {
      inciarComponente() {
        this.obtenerOficinas()
      },

      getIpMacAddress (art) {
        let texto
        if (art.direccionIP) {
          if (art.macAddressW) {
              if (art.macAddressE) {
                texto = `<span class="tag is-black">${art.direccionIP}</span>
                        <p class="is-size-7"><b>W.</b> ${art.macAddressW}<br/>
                        <b>E.</b> ${art.macAddressE}<br/>
                        </p>`
              } else {
                texto = `<span class="tag is-black">${art.direccionIP}</span>
                        <p class="is-size-7"><b>W.</b> ${art.macAddressW}<br/>
                        </p>`
              }
          } else {
            if (art.macAddressE) {
              texto = `<span class="tag is-black">${art.direccionIP}</span>
                <p class="is-size-7"><b>E.</b> ${art.macAddressE}<br/>
                </p>`
            } else {
              texto = `<span class="tag is-black">${art.direccionIP}</span>`
            }
          }
        } else {
          if (art.macAddressW) {
              if (art.macAddressE) {
                texto = `<b>W.</b> ${art.macAddressW}<br/>
                        <b>E.</b> ${art.macAddressE}<br/>
                        </p>`
              } else {
                texto = `<b>W.</b> ${art.macAddressW}<br/>
                        </p>`
              }
          } else {
            if (art.macAddressE) {
              texto = `<b>E.</b> ${art.macAddressE}<br/>
                </p>`
            } else {
              texto = ``
            }
          }
        }
        return texto
      },

      getGarantia (art) {
        let texto =''

        if (art.garantia === '0') {

          if (art.terminoGarantia ==='0000-00-00') {
            texto = `<span class="tag is-danger"><i class="fas fa-ban"></i>&nbsp No tiene Garantía</span><br/>
              <p class="is-size-7"><b>Se terminó:</b> <i>No existe Info.</i></p>
              `
          } else {
            texto = `<span class="tag is-danger"><i class="fas fa-ban"></i>&nbsp No tiene Garantía</span><br/>
              <p class="is-size-7"><b>Se terminó:</b> <i>${art.terminoGarantia}</i></p>
              `
          }

        } else {
          if (art.terminoGarantia ==='0000-00-00') {
            texto = `<span class="tag is-success"><i class="fas fa-check-circle"></i>&nbsp Con Garantía</span>`
          } else {
            texto = `<span class="tag is-success"><i class="fas fa-check-circle"></i>&nbsp Con Garantía</span><br/>
              <p class="is-size-7"><b>Termina:</b> <i>${art.terminoGarantia}</i></p>`
          }
        }

        return texto
      },

      verHistoria (id) {
        this.$router.push({ path: `/Inventario/Historia/${id}` } )
      },

      irAResguardos (id) {
        this.$router.push({ path: `/Inventario/Resguardos/${id}` } )
      },

      getOC_FC (art) {
        let texto = ''
        if(art.ordenCompra === '') {

          if (art.fechaCompra === '0000-00-00'){
            texto = `<span class="is-size-7">
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>
            </span>
            `
          } else {
            texto = `<span class="is-size-7">${art.fechaCompra}
                <a class="button is-black is-rounded is-small">
                  <i class="fas fa-history"></i>
                </a>
              </span>
              `
          }
        } else {
            if (art.fechaCompra === '0000-00-00'){
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}
              <a class="button is-black is-rounded is-small">
                <i class="fas fa-history"></i>
              </a>
              </span>
              `
            } else {
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}</span>
                <span class="is-size-7">${art.fechaCompra}
                  <a class="button is-black is-rounded is-small">
                    <i class="fas fa-history"></i>
                  </a>
                </span>
                `
            }
        }

        return texto
      },

      irEditarArticulo(data) {
        if (this.permisos.inventarios == 6) {
          return
        }
        this.$router.push({ path: `/Inventario/ArticuloDetalle/${data.id}` })
      },
      
      cambiarUbicacion(item) {
        if (this.permisos.inventarios == 6) {
          return
        }
        if (this.userLogin.departamento === 3 || this.userLogin.departamento === 1 || this.userLogin.cargo === "321" || this.userLogin.cargo === "323" || this.userLogin.cargo === "324" || this.userLogin.cargo === "002") {
          this.itemCambiar = item
          this.configModal = {
            title: 'Ubicar equipo',
            content: `Seleccione la ubicación y el estatus de: ${item.descripcion}.`,
            textCancel: 'Cancelar',
            textOk: 'Guardar',
          }
          this.modalStatus = true
        }
      },

      selectNewOffice (result) {
        if (result === 'close') {
          this.modalStatus = false
          return
        }
        this.isLoading = true
        if ( Object.keys(result).length > 0 ) {
          if (result.estatus != 12) {
            let id = Date.now()
            let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
            const ubi = result.ubicacion ? result.ubicacion : this.itemCambiar.ubicacionArt
            const ofi = result.oficina ? result.oficina : this.itemCambiar.oficinaArt

            let idEntrega = ''
            let entrega = ''
            let idRecibe = ''
            let recibe = ''
            let localizacion = 0
            switch (result.estatus) {
              case 6:
                idEntrega = result.idUserAlmacen
                entrega = result.userAlmacen
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
                localizacion = result.id_localizacion
                break
              case 7:
                idEntrega = this.itemCambiar.idIngresa
                entrega = this.itemCambiar.ingresa
                idRecibe = this.itemCambiar.idResguardo
                recibe = this.itemCambiar.resguardo
                break
              case 8:
                idEntrega = result.idUserAlmacen
                entrega = result.userAlmacen
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
                break
              case 9:
                idEntrega = result.idUserAlmacen
                entrega = result.userAlmacen
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
                localizacion = result.id_localizacion
                break
              case 10:
                idEntrega = result.idUserAlmacen
                entrega = result.userAlmacen
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
                localizacion = result.id_localizacion ? result.id_localizacion : 0
                break
              case 11:
                idEntrega = '1538165924968'
                entrega = 'Administrador'
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
              case 12:
                idEntrega = '1538165924968'
                entrega = 'Administrador'
                idRecibe = result.idUserAlmacen
                recibe = result.userAlmacen
                break
            }
            
            InventarioServices.addUbicacion(id, this.itemCambiar.id, fechaReg, ubi, ofi, idEntrega, entrega, idRecibe, recibe, result.estatus)
              .then((data) => {
                  InventarioServices.updateLocalizacion(this.itemCambiar.id, localizacion)
                  .then( dataloc => {
                    if (dataloc.success) {
                      this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
                      this.$emit('updateArticulos', true)
                    } else {
                      this.displayToast('bubble', dataloc.respuesta, 'ban', 'OK')
                    }
                  })
                  .catch( e => {
                    this.isLoading = false
                    this.displayToast('bubble',e.message, 'ban', 'OK')      
                  })
              })
              .catch((e) => {
                this.isLoading = false
                this.displayToast('bubble',e.message, 'ban', 'OK')
              })
          } else {
            this.isLoading = false
            this.$store.commit('bajaArticulo', this.itemCambiar.id)
            this.$router.push('/Inventario/Almacen/Bajas/Nueva')
          }

        }
        this.modalStatus = false
      },

      getEstado (child) {
        let html = ''
        switch (child.estado) {
          case 7:
            html = ` <span class='tag is-info'><i class="fas fa-laptop-house">&nbspPruebas</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 8:
            html = ` <span class='tag is-warning'><i class="fas fa-tools"></i>&nbspReparación</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 9:
            html = ` <span class='tag is-success'><i class="fas fa-database"></i>&nbspInstalado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 10:
            html = ` <span class='tag is-danger'><i class="far fa-trash-alt"></i>&nbspDesechado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        
          default:
            html = ` <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        }
        return html
      },

      getClassTipo (item, tipo) {
        const { documentos } = item
        const isFiles = documentos.some( d => d.tipo === tipo)
        return isFiles ? 'is-success' : 'is-warning'
      },
      
      verModalD (data, tipo) {
        this.itemSelect = data
        this.modalStatusD = true
        this.tipoFileUp = tipo
      },

      cerrarModalD () {
        this.itemSelect = {}
        this.modalStatusD = false
      },

      subirDocumento (doctos) {
        this.modalStatusD = false
        this.isLoading = true
        const files = Array.from(doctos)
        if (files.length > 0) {
          var i = 0
          files.forEach(docto => {
            
            const nombreFile = docto.name
            let tipoInt = 0
            if (this.tipoFileUp !== 'facturas') {        
              switch (this.tipoFileUp) {
                case 'images':
                  tipoInt = 0
                  break
                case 'facturas':
                  tipoInt = 1
                  break
                case 'polizas':
                  tipoInt = 2
                  break
                case 'tarjetaCirc':
                  tipoInt = 3
                  break
              }
              InventarioServices.uploadDocumento(this.itemSelect.id, nombreFile, docto, tipoInt)
                .then(data => {
                  if (data.success) { i++}
                  
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  if (i== doctos.length) {
                    this.isLoading = false
                    this.$emit('updateChildrens', this.itemSelect)
                  }
                })
                .catch( error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })  
            } else {
              InventarioServices.subirFactura(this.itemSelect.id, nombreFile, docto)
                .then( data => {
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  this.isLoading = false
                  this.$emit('updateChildrens', this.itemSelect)
                })
                .catch(error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })
            }
          })
          
        } else {
          this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
          this.isLoading = false
        }
        
      },
      
      verModalDeleteDocumento (docto) {
      
        let title = ''
        let content = ''

        switch (this.tipoFileUp) {
          case 'images':
            title = 'Eliminar Documento'
            content = '¿Desea eliminar el documento?'
            break
          case 'facturas':
            title = 'Eliminar Factura'
            content = '¿Desea eliminar la factura?'
            break
          case 'polizas':
            title = 'Eliminar Póliza'
            content = '¿Desea eliminar la póliza?'
            break
        }

        this.configModalYN = {
          title: title,
          content: content,
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.modalStatusD = false
        this.documentoSelect = docto
        this.modalStatusYN = true
      },

      borrarDocumento (result) {
        this.modalStatusYN = false
        this.isLoading = true
        if (result) {
          
          if (this.documentoSelect.tipo === 'documento') {
            InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          } else {
            InventarioServices.deleteFactura(this.documentoSelect.id, this.documentoSelect.rutaFac)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        } else {
          this.isLoading = false
          this.modalStatusD = true
        }
        this.documentoSelect = {}
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      obtenerOficinas() {
        InventarioServices.getOficinas()
          .then( data => {
            this.oficinas = data.map(this.convertirOficinas)
            this.obtenerEstados()
          })
          .catch((e) => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          })
      },

      convertirOficinas(ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          oficina: ofi.nombre,
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      obtenerEstados() {
        InventarioServices.getEstadosUso()
          .then( data => {
            this.estadosDB = data.map(this.convertirEstadosUso)
            this.obtenerLocalizaciones()
          })
          .catch((e) => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          })
      },

      convertirEstadosUso(est) {
        return {
          ...est,
          id: parseInt(est.id)
        }
      },

      obtenerLocalizaciones() {
      InventarioServices.getLocalizaciones()
        .then( data => {
          this.localizaciones = data.map(this.convertirLocalizaciones)
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
      },

      convertirLocalizaciones(loc) {
        return {
          ...loc,
          id: parseInt(loc.id),
          id_oficina: parseInt(loc.id_oficina),
        }
      },
    },
    created () {
      this.inciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'permisos'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/TbAlmacenes.vue